import { makeAutoObservable, runInAction } from "mobx";

export interface NotificationProps {
  title: string;
  content: string;
  button?: {
    label: string;
    onClick: () => void;
  };
  duration?: number;
  type?: "success" | "error" | "info" | "warning";
}

export interface ToastItem extends NotificationProps {
  id: number;
  isClosing?: boolean;
}

export class ToastStore {
  // ==================== STATE ====================
  toasts: ToastItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  // ==================== ACTIONS ====================
  show = (data: NotificationProps) => {
    const id = Date.now() + Math.random();
    runInAction(() => {
      this.toasts.push({ ...data, id });
    });
    return id;
  };

  close = (id: number) => {
    this.setClosing(id);
    setTimeout(() => {
      runInAction(() => {
        this.toasts = this.toasts.filter((t) => t.id !== id);
      });
    }, 200);
  };

  // ==================== PRIVATE METHODS ====================
  private setClosing = (id: number) => {
    runInAction(() => {
      this.toasts = this.toasts.map((t) => (t.id === id ? { ...t, isClosing: true } : t));
    });
  };
}
